import type { IUserProfileStatistic as IUserProfileStatisticDto } from '../../../repositories/chats/entities/user_profile/UserProfileStatistic';
import type { IUserProfileStatistics } from '../../../types/userProfile';

export const mapStatistics = (
  statistic: IUserProfileStatisticDto | null | undefined,
): IUserProfileStatistics | null => {
  if (!statistic) {
    return null;
  }

  const { title, parameters } = statistic;

  return {
    title,
    parameters,
  };
};
